import React from 'react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SwapVertIcon from '@mui/icons-material/SwapVert';

interface SwapButtonProps {
  onClick: () => void;
  direction: 'horizontal' | 'vertical';
  className?: string;
}

const SwapButton: React.FC<SwapButtonProps> = ({ onClick, direction, className = '' }) => {
  const Icon = direction === 'horizontal' ? SwapHorizIcon : SwapVertIcon;

  return (
    <button
      onClick={onClick}
      onMouseDown={(e) => e.stopPropagation()}
      className={`
        flex items-center justify-center
        w-[20px] h-[20px]
        rounded-full
        bg-gray-300 dark:bg-gray-700
        hover:bg-gray-400 dark:hover:bg-gray-600
        text-gray-500 dark:text-gray-400
        hover:text-gray-800 dark:hover:text-white
        transition-colors duration-200
        cursor-pointer
        z-10
        ${className}
      `}
      title={direction === 'horizontal' ? 'Swap columns' : 'Swap top/bottom'}
    >
      <Icon style={{ fontSize: 14 }} />
    </button>
  );
};

export default SwapButton;
